import Actions             from 'Redux/Actions';
import { AppUserRepository } from 'Domain/Repositories';
import { ofType }          from 'redux-observable';
import { from }            from 'rxjs';
import { mergeMap }        from 'rxjs/operators';
import { TEpic }           from 'Redux/Config';

export const removeAppUserFromOrganisationEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.removeAppUserFromOrganisationRequest.type),
    mergeMap(action => from(
      AppUserRepository.removeAppUserFromOrganisation(action.payload)
        .then(() => Actions.removeAppUserFromOrganisationSuccess({ appUserId: action.payload.appUserId }))
        .catch((error: Error) => Actions.removeAppUserFromOrganisationFailure({ error })),
    )),
  );
};
